import { render, staticRenderFns } from "./UserNotFound.vue?vue&type=template&id=7823f839&scoped=true&"
import script from "./UserNotFound.vue?vue&type=script&lang=js&"
export * from "./UserNotFound.vue?vue&type=script&lang=js&"
import style0 from "./UserNotFound.vue?vue&type=style&index=0&id=7823f839&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7823f839",
  null
  
)

export default component.exports